import { createAction, props } from '@ngrx/store';
import { FirmaItem } from '../../firma.model';

export const editFirmaStart = createAction('MITARBEITERVERWALTUNG::EDIT_FIRMA_START', props<{ item: FirmaItem }>());
export const editFirmaSucceeded = createAction('MITARBEITERVERWALTUNG::EDIT_FIRMA_SUCCEEDED', props<{ item: FirmaItem }>());
export const editFirmaFailed = createAction('MITARBEITERVERWALTUNG::EDIT_FIRMA_FAILED', props<{ error: Error }>());
